import {
    GALLERY_DETAILS_FILTER_PAGE_NEXT,
    GALLERY_DETAILS_FILTER_PAGE_PREV,
    GALLERY_DETAILS_FILTER_PAGE_RESET
} from './constants';

export const galleryDetailReset = (payload) => ({
    type: GALLERY_DETAILS_FILTER_PAGE_RESET,
    payload
});

export const nextPage = () => ({
    type: GALLERY_DETAILS_FILTER_PAGE_NEXT,
    payload: {}
});

export const prevPage = () => ({
    type: GALLERY_DETAILS_FILTER_PAGE_PREV,
    payload: {}
});